import { AdBlock } from '@hhgtech/hhg-components'
import { Box, Stack } from '@mantine/core'

import { ArticleCardWrapper } from 'components/molecules/articleCardWrapper'
import { useIsMobile } from 'hooks/useIsMobile'
import { Article, ArticleDisplayType, Category } from 'interfaces/types'

import { Categories } from '../categories'

type Props = {
  categories?: Category[]
  layout?: ArticleDisplayType
  adUnitPath?: string
  articles: Article[]
  dataTrackingCommon: any
}

export const SingleNormalLayout = ({
  layout,
  articles,
  categories,
  adUnitPath,
  dataTrackingCommon,
}: Props) => {
  const isMobile = useIsMobile()
  const listingEle = (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 24,
        flexWrap: 'wrap',
        '.card-item': {
          padding: '0 !important',
          ...(layout === 'list-contain-ads' && {
            width: '100%',
            ...(!adUnitPath &&
              !isMobile &&
              articles.length > 1 && {
                width: `calc((100% - 32px)/2)`,
              }),
          }),
          ...(layout === 'grid' && {
            width: `calc((100% - 64px)/${adUnitPath ? 2 : 3})`,
            '&[data-direction=vertical] .banner': {
              height: 240,
            },
          }),
        },
        [theme.fn.largerThan('sm')]: {
          gap: 32,
        },
      })}
      //   {...wrapperListProps}
    >
      {articles.map((article, idx) => (
        <ArticleCardWrapper
          key={String(idx)}
          className="card-item"
          article={article}
          {...dataTrackingCommon(article)}
          isMobile={isMobile}
          type="author"
          size={isMobile ? 'sm' : 'md'}
          direction={layout === 'list-contain-ads' ? 'horizontal' : 'vertical'}
          hideBookmark
          //   {...cardProps}
        />
      ))}
    </Box>
  )
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 24,
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
        },
        [theme.fn.largerThan('sm')]: {
          gap: 68,
        },
      })}
    >
      <Stack spacing={40}>
        {listingEle}
        <Categories categories={categories} />
      </Stack>
      {adUnitPath && !isMobile && (
        <Box
          sx={{
            position: 'relative',
            width: 300,
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 80,
            }}
          >
            <AdBlock
              adUnitPath={adUnitPath}
              size={[
                [300, 250],
                [300, 600],
              ]}
              divId={'article-top-banner-desktop'}
              pos={['TopBanner']}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
